import React from 'react';
import {
  IoCall,
  IoGlobeOutline,
  IoLocation,
  IoLogoBehance,
  IoLogoBitbucket,
  IoLogoCodepen,
  IoLogoDiscord,
  IoLogoDribbble,
  IoLogoFacebook,
  IoLogoFoursquare,
  IoLogoGithub,
  IoLogoGitlab,
  IoLogoInstagram,
  IoLogoLinkedin,
  IoLogoMedium,
  IoLogoPinterest,
  IoLogoReddit,
  IoLogoRss,
  IoLogoSkype,
  IoLogoSlack,
  IoLogoSnapchat,
  IoLogoSoundcloud,
  IoLogoTiktok,
  IoLogoTumblr,
  IoLogoTwitter,
  IoLogoVimeo,
  IoLogoVk,
  IoLogoWhatsapp,
  IoLogoYoutube,
  IoMail,
} from "react-icons/io5";

// The social data directly included
const socialData = {
  "facebook": "https://www.facebook.com/profile.php?id=61569922716685",
  "twitter": "https://x.com/chatmitra_chat",
  "instagram": "https://www.instagram.com/chatmitra_official",
  "youtube": "https://www.youtube.com/@chatmitra_official",
  "linkedin": "https://www.linkedin.com/company/chat-mitra",
  "github": "",
  "gitlab": "",
  "discord": "",
  "slack": "",
  "medium": "",
  "codepen": "",
  "bitbucket": "",
  "dribbble": "",
  "behance": "",
  "pinterest": "https://in.pinterest.com/chatmitra_official/",
  "soundcloud": "",
  "tumblr": "",
  "reddit": "",
  "vk": "",
  "whatsapp": "https://wa.me/917698242507",
  "snapchat": "",
  "vimeo": "",
  "tiktok": "",
  "foursquare": "",
  "rss": "",
  "email": "chatmittra@gmail.com",
  "phone": "",
  "address": "",
  "skype": "",
  "website": ""
};

// The footer menu data directly included
const footerMenu = [
  {
    "name": "Chat Mitra",
    "menu": [
      { "text": "Features", "url": "/features" },
      { "text": "Integrations", "url": "/integrations" },
      { "text": "Pricing", "url": "/pricing" },
      { "text": "Blog", "url": "/blogs" },
      { "text": "FAQs", "url": "https://faq.chatmitra.com" },
      { "text": "Case Studies", "url": "/case-studies" }, 
      { "text": "Contact Us", "url": "/contact" },
      { "text": "Careers", "url": "/career" }
    ]
  },
  {
    "name": "Compare",
    "menu": [
      { "text": "with Aisensy", "url": "/chatmitra-vs-aisensy" },
      { "text": "with Wati", "url": "/chatmitra-vs-wati" },
      { "text": "with Interakt", "url": "/chatmitra-vs-interakt" },
      { "text": "with Gallabox", "url": "/chatmitra-vs-gallabox" },
      { "text": "with Delight Chat", "url": "/chatmitra-vs-delight-chat" },
      { "text": "with Business on Bot", "url": "/chatmitra-vs-businessonbot" },
      { "text": "with Bitespeed", "url": "/chatmitra-vs-bitespeed" }
    ]
  },
  {
    "name": "Free Whatsapp Tools",
    "menu": [
      { "text": "Whatsapp Chat Link Generator", "url": "/create-whatsapp-chat-link" },
      { "text": "Whatsapp QR Code Generator", "url": "/free-whatsapp-qr-code-generator" },
      { "text": "Whatsapp Conversation Pricing Calculator", "url": "/whatsapp-business-api-pricing-calculator" }
    ]
  },
  {
    "name": "Legal",
    "menu": [
      { "text": "Privacy Policy", "url": "/privacy-policy" },
      { "text": "Refund Policy", "url": "/refund-policy" },
      { "text": "Terms & Conditions", "url": "/terms-of-service" }
    ]
  }
];

// Configuration directly included
const config = {
  site: {
    logo: "/images/logo.png", // Update with your actual logo path
    logo_width: 160,
    logo_height: 48
  },
  params: {
    copyright: "© 2025 Chat Mitra. All rights reserved.",
    footer_content: "The ultimate WhatsApp Business API solution for your business needs."
  }
};

// Social component directly included in the same file
const Social = ({ source, className }) => {
  const {
    facebook,
    twitter,
    instagram,
    youtube,
    linkedin,
    github,
    gitlab,
    discord,
    slack,
    medium,
    codepen,
    bitbucket,
    dribbble,
    behance,
    pinterest,
    soundcloud,
    tumblr,
    reddit,
    vk,
    whatsapp,
    snapchat,
    vimeo,
    tiktok,
    foursquare,
    rss,
    email,
    phone,
    address,
    skype,
    website,
  } = source;
//   {console.log("source:", source)}

 

  return (
    <ul className={'social-icons mb-6 '}>
      <style>
        {`
          .icon {
            fill: #075E54 !important;
            transition: fill 0.3s ease-in-out;
          }

          .icon:hover {
            fill: #fff !important;
            background:#075E54 !important;
          }
        `}
      </style>
      {facebook && (
        <li className="inline-block ">
          <a
            aria-label="facebook"
            href={facebook}
            target="_blank"
            rel="noopener noreferrer"
            className="!bg-white p-2 rounded-full inline-flex items-center justify-center"
          >
            <IoLogoFacebook className='icon'/>
          </a>
        </li>
      )}
      {twitter && (
        <li className="inline-block">
          <a
            aria-label="twitter"
            href={twitter}
            target="_blank"
            rel="noopener noreferrer"
            className="!bg-white p-2 rounded-full inline-flex items-center justify-center icon"
          >
            <IoLogoTwitter className='icon'/>
          </a>
        </li>
      )}
      {instagram && (
        <li className="inline-block">
          <a
            aria-label="instagram"
            href={instagram}
            target="_blank"
            rel="noopener noreferrer"
            className="!bg-white p-2 rounded-full inline-flex items-center justify-center icon"
          >
            <IoLogoInstagram className='icon'/>
          </a>
        </li>
      )}
      {youtube && (
        <li className="inline-block">
          <a
            aria-label="youtube"
            href={youtube}
            target="_blank"
            rel="noopener noreferrer"
            className="!bg-white p-2 rounded-full inline-flex items-center justify-center icon"
          >
            <IoLogoYoutube className='icon'/>
          </a>
        </li>
      )}
      {linkedin && (
        <li className="inline-block">
          <a
            aria-label="linkedin"
            href={linkedin}
            target="_blank"
            rel="noopener noreferrer"
            className="!bg-white p-2 rounded-full inline-flex items-center justify-center icon"
          >
            <IoLogoLinkedin className='icon'/>
          </a>
        </li>
      )}
      {github && (
        <li className="inline-block">
          <a
            aria-label="github"
            href={github}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoGithub className='icon'/>
          </a>
        </li>
      )}
      {gitlab && (
        <li className="inline-block">
          <a
            aria-label="gitlab"
            href={gitlab}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoGitlab className='icon'/>
          </a>
        </li>
      )}
      {discord && (
        <li className="inline-block">
          <a
            aria-label="discord"
            href={discord}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoDiscord className='icon'/>
          </a>
        </li>
      )}
      {slack && (
        <li className="inline-block">
          <a
            aria-label="slack"
            href={slack}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoSlack className='icon'/>
          </a>
        </li>
      )}
      {medium && (
        <li className="inline-block">
          <a
            aria-label="medium"
            href={medium}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoMedium className='icon'/>
          </a>
        </li>
      )}
      {codepen && (
        <li className="inline-block">
          <a
            aria-label="codepen"
            href={codepen}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoCodepen className='icon'/>
          </a>
        </li>
      )}
      {bitbucket && (
        <li className="inline-block">
          <a
            aria-label="bitbucket"
            href={bitbucket}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoBitbucket className='icon'/>
          </a>
        </li>
      )}
      {dribbble && (
        <li className="inline-block">
          <a
            aria-label="dribbble"
            href={dribbble}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoDribbble className='icon'/>
          </a>
        </li>
      )}
      {behance && (
        <li className="inline-block">
          <a
            aria-label="behance"
            href={behance}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoBehance className='icon'/>
          </a>
        </li>
      )}
      {pinterest && (
        <li className="inline-block">
          <a
            aria-label="pinterest"
            href={pinterest}
            target="_blank"
            rel="noopener noreferrer"
            className="!bg-white p-2 rounded-full inline-flex items-center justify-center"
          >
            <IoLogoPinterest className='icon'/>
          </a>
        </li>
      )}
      {soundcloud && (
        <li className="inline-block">
          <a
            aria-label="soundcloud"
            href={soundcloud}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoSoundcloud className='icon'/>
          </a>
        </li>
      )}
      {tumblr && (
        <li className="inline-block">
          <a
            aria-label="tumblr"
            href={tumblr}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoTumblr className='icon'/>
          </a>
        </li>
      )}
      {reddit && (
        <li className="inline-block">
          <a
            aria-label="reddit"
            href={reddit}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoReddit className='icon'/>
          </a>
        </li>
      )}
      {vk && (
        <li className="inline-block">
          <a
            aria-label="vk"
            href={vk}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoVk className='icon'/>
          </a>
        </li>
      )}
      {whatsapp && (
        <li className="inline-block">
          <a
            aria-label="whatsapp"
            href={whatsapp}
            target="_blank"
            rel="noopener noreferrer"
            className="!bg-white p-2 rounded-full inline-flex items-center justify-center"
          >
            <IoLogoWhatsapp className='icon'/>
          </a>
        </li>
      )}
      {snapchat && (
        <li className="inline-block">
          <a
            aria-label="snapchat"
            href={snapchat}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoSnapchat className='icon'/>
          </a>
        </li>
      )}
      {vimeo && (
        <li className="inline-block">
          <a
            aria-label="vimeo"
            href={vimeo}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoVimeo className='icon'/>
          </a>
        </li>
      )}
      {tiktok && (
        <li className="inline-block">
          <a
            aria-label="tiktok"
            href={tiktok}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoTiktok className='icon'/>
          </a>
        </li>
      )}
      {foursquare && (
        <li className="inline-block">
          <a
            aria-label="foursquare"
            href={foursquare}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoFoursquare className='icon'/>
          </a>
        </li>
      )}
      {skype && (
        <li className="inline-block">
          <a
            aria-label="skype"
            href={skype}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white"
          >
            <IoLogoSkype className='icon'/>
          </a>
        </li>
      )}
      {website && (
        <li className="inline-block">
          <a
            aria-label="website"
            href={website}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoGlobeOutline className='icon'/>
          </a>
        </li>
      )}
      {rss && (
        <li className="inline-block">
          <a
            aria-label="rss feed"
            href={rss}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLogoRss className='icon'/>
          </a>
        </li>
      )}
      {email && (
        <li className="inline-block">
          <a aria-label="email" href={`mailto:${email}`} className="!bg-white p-2 rounded-full inline-flex items-center justify-center">
            <IoMail className='icon'/>
          </a>
        </li>
      )}
      {phone && (
        <li className="inline-block">
          <a aria-label="telephone" href={`tel:${phone}`}>
            <IoCall className='icon'/>
          </a>
        </li>
      )}
      {address && (
        <li className="inline-block">
          <a
            aria-label="location"
            href={address}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoLocation className='icon'/>
          </a>
        </li>
      )}
    </ul>
  );
};

// Helper function to replace markdownify
const markdownify = (content, tag, className) => {
  const Tag = tag || "span";
  return <Tag className={className} dangerouslySetInnerHTML={{ __html: content }} />;
};

// Main Footer component
const Footer = () => {
  const { copyright, footer_content } = config.params;

  return (
    <footer className="footer bg-[#075E54] text-white py-12">
      <div className="container mx-auto">
        {/* footer menu */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8">
          {footerMenu.map((col) => (
            <div key={col.name}>
              {markdownify(col.name, "h2", "text-xl font-bold mb-4 text-white")}
              <ul>
                {col?.menu.map((item) => (
                  <li className="mb-2" key={item.text}>
                    <a 
                      href={item.url} 
                      className="hover:text-[#128C7E] transition-colors duration-300"
                    >
                      {item.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          {/* Social Icons */}
          <div className="text-center">
            <a href="/" aria-label="Bigspring">
              <img
                src={'./logo.png'}
                width={"85"}
                height={"60"}
                alt="Chat Mitra Logo"
                className="mx-auto mb-4"
              />
            </a>
            {console.log("Social Data:", socialData)}

            {markdownify(footer_content, "p", "text-lg mb-6")}
            <Social source={socialData} className="social-icons mb-6" />
          </div>
        </div>
        {/* copyright */}
        <div className="border-t border-gray-200 mt-8 pt-4 text-center">
          {markdownify(copyright, "p", "text-sm")}
        </div>
      </div>
    </footer>
  );
};

export default Footer;